import { NavLink, useNavigate } from 'react-router-dom';
import {
  IconAssignment,
  IconMap,
  IconPlus,
  IconRank,
  IconSection,
} from '../components/icons';

/* Five destinations with capture raised out of the row.
 *
 * Every tab carries a word as well as a glyph. Icon-only navigation assumes
 * the user has time to decode it; this one is read at arm's length with the
 * sun behind you, sometimes by someone who opens the app twice a week. */

const TABS = [
  { to: '/', label: 'Today', Icon: IconSection, end: true },
  { to: '/priorities', label: 'Priorities', Icon: IconRank },
  { to: '/assigned', label: 'Assigned', Icon: IconAssignment },
  { to: '/map', label: 'Map', Icon: IconMap },
];

export function TabBar() {
  const navigate = useNavigate();

  return (
    <nav className="tabs" aria-label="Main">
      <>
        {TABS.slice(0, 2).map(({ to, label, Icon, end }) => (
          <NavLink key={to} to={to} end={end} className="tab">
            <Icon size={23} />
            {label}
          </NavLink>
        ))}

        {/* The capture button is not a tab. It is the reason the app exists,
            so it is bigger, it is rust, and it sits above the row. */}
        <button
          type="button"
          className="fab"
          onClick={() => navigate('/capture')}
          aria-label="Capture evidence"
        >
          <IconPlus size={30} />
        </button>

        {TABS.slice(2).map(({ to, label, Icon }) => (
          <NavLink key={to} to={to} className="tab">
            <Icon size={23} />
            {label}
          </NavLink>
        ))}
      </>
    </nav>
  );
}
